import React from "react";

import { PriceProperties } from "../../types/prices";
import { SetVersionOnWindow } from "../../util/version-logger";
import PriceErrorBoundary from "../PriceErrorBoundary";
import VatMessage from "../legacy/VatMessage";

//Accept priceProperties and display VAT Message
interface TaxPresentationProps {
  priceProperties: Pick<PriceProperties, "locale" | "vatInc" | "hideShippingMessageInVatMessage">;
  /** @deprecated synchronous rendering makes this prop unnecessary; it is ignored */
  placeHolderText?: string;
  className?: string;
}

const TaxPresentation = ({
  priceProperties,
  placeHolderText: _placeHolderText,
  className,
}: TaxPresentationProps) => {
  SetVersionOnWindow();

  return (
    <PriceErrorBoundary fallbackUi={<></>}>
      <VatMessage
        locale={priceProperties.locale}
        vatInc={priceProperties.vatInc}
        hideShippingMessageInVatMessage={priceProperties.hideShippingMessageInVatMessage}
        className={className}
      />
    </PriceErrorBoundary>
  );
};

export { TaxPresentation };
export type { TaxPresentationProps };
export default TaxPresentation;
